export enum DataFetchState {
  Loading = 'Loading',
  Empty = 'Empty',
  Error = 'Error',
  Data = 'Data',
}
